import styled from '@emotion/styled';
import { toggle } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

interface TogglePropsType {
  isDisabled?: boolean;
}

export const ToggleWrapper = styled('div', { label: 'ToggleWrapper' })<TogglePropsType>`
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.regular};
    line-height: 1.3334;
    color: ${toggle.txtColor};
    margin-bottom: 16px;
    ${({ isDisabled }): string => isDisabled === true ? 'pointer-events: none; opacity: 0.4' : ''};
`;

export const SliderWrapper = styled('div', { label: 'SliderWrapper' })`
    position: relative;
    width: 28px;
    height: 16px;
    margin-left: 8px;
`;

export const Input = styled('input', { label: 'Input' })`
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
    background-color: ${toggle.bgColorSecondary};

    &:checked + span {
      background-color: ${toggle.bgColor};
    }

    &:checked + span:before {
      transform: translateX(12px);
    }
`;

export const Slider = styled('span', { label: 'Slider' })`
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: ${toggle.bgColorSecondary};
    border-radius: 8px;
    box-sizing: border-box;

    &:before {
        position: absolute;
        content: "";
        height: 12px;
        width: 12px;
        box-sizing: border-box;
        inset: 2px auto auto 2px;
        background-color: ${toggle.bgColorTertiary};
        transition: transform .2s ease;
        border-radius: 50%;
    }
`;
